exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2QhXDzQc92AAJ8{color:#8993a4;padding:0 4px}._2QhXDzQc92AAJ8:hover{color:#091e42}._2_JqGosBLzpgCG{margin:0}._2nlsR5BDZms-lO{display:flex;justify-content:space-between;align-items:center;margin-top:12px}.QUcutfN8RVSQzJ{display:block}", ""]);

// exports
exports.locals = {
	"downloadLink": "_2QhXDzQc92AAJ8",
	"exportButton": "_2_JqGosBLzpgCG",
	"buttons": "_2nlsR5BDZms-lO",
	"exportHistoryText": "QUcutfN8RVSQzJ"
};